<template>
  <div class="maintainTemplate">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="80px">
      <el-form-item label="维护类型">
        <DicInput @fieldId="fieldId($event,'TypeId')" :dicType="5"></DicInput>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="name"
            label="名称">
        </el-table-column>
        <el-table-column
            prop="code"
            label="编号">
        </el-table-column>
        <el-table-column
            prop="note"
            label="备注"
            align="center">
        </el-table-column>
        <el-table-column
            prop="deviceTypeName"
            label="设备型号名称"
            align="center">
        </el-table-column>
        <el-table-column
            prop="firstMaintain"
            label="首次维护时间"
            align="center">
        </el-table-column>
        <el-table-column
            prop="maintainInterval"
            label="维护周期"
            align="center">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
            <el-button type="text" size="medium" @click="moreClick(scope.row.id)">保养明细</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--    &lt;!&ndash; 分页 &ndash;&gt;-->
    <!--    <div style="margin-top: 20px">-->
    <!--      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'-->
    <!--                  @handleCurrentChange='handleCurrentChange'></Pagination>-->
    <!--    </div>-->
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="编号" prop="code">
          <el-input v-model="ruleForm.code" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="激活" prop="firstMaintain">
          <el-input v-model="ruleForm.firstMaintain" style="width: 200px" placeholder="请输入"></el-input>
          <span style="margin-left: 10px">天以后首次维护</span>
        </el-form-item>
        <el-form-item label="维护间隔" prop="maintainInterval">
          <el-input v-model="ruleForm.maintainInterval" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="设备型号" required>
          <DicInput style="width: 100%" :defaultName="ruleForm.deviceTypeName" :initName="ruleForm.deviceTypeName"
                    @fieldId="ruleFormFieldId($event,'deviceTypeId')" :dicType="1"></DicInput>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ruleForm.note" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="模板明细"
        :close-on-click-modal="false"
        :visible.sync="templateVisible"
        width="60%">
      <div class="flex align-center">
        <div style="border: 1px solid #c9cdd6">
          <el-table
              :header-cell-style="{background:'#F5F5F5'}"
              :data="templateTableData"
              style="width: 800px" :row-class-name="tableRowClassName">
            <el-table-column
                label="保养类型名称"
                prop="name">
            </el-table-column>
            <el-table-column
                label="距离上次保养天数"
                prop="fromLast">
            </el-table-column>
            <el-table-column
                label="备注"
                prop="note">
            </el-table-column>
            <el-table-column label="操作" width="240px">
            <template slot="header" slot-scope="scope">
              <el-button type="primary" @click="firstAdd()">首行插入</el-button>
            </template>
              <template slot-scope="scope">
                <el-button type="text" icon="el-icon-top" size="medium" @click="topClick(scope.row)" circle></el-button>
                <el-button type="text" icon="el-icon-bottom" size="medium" @click="bottomClick(scope.row)" circle></el-button>
                <el-button type="text" icon="el-icon-plus" @click="addTemplate(scope.row)" size="medium" circle></el-button>
                <el-button type="text" icon="el-icon-edit"  @click="editTemplate(scope.row)" size="medium" circle></el-button>
                <el-button type="text" icon="el-icon-delete" size="medium" @click="delClick(scope.row)" circle></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-form :model="templateForm"  ref="templateForm" label-width="110px" class="demo-ruleForm">
            <el-form-item label="上一项保养" v-show="this.show">
              <el-input v-model="templateForm.upText" placeholder="请输入" disabled></el-input>
            </el-form-item>
            <el-form-item label="类型名称" required>
              <DicInput style="width: 100%" :defaultName="templateForm.name" :initName="templateForm.name"
                        @fieldId="templateFieldId($event,'maintainTypId')" :dicType="5"></DicInput>
            </el-form-item>
            <el-form-item label="备注">
              <el-input  v-model="templateForm.note" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="维护间隔">
              <el-input  v-model="templateForm.fromLast" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="templateSubmitForm('templateForm')">立即创建</el-button>
              <el-button @click="resetForm('templateForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">

      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import DicInput from "@/components/DicInput";

export default {
  name: "maintainTemplate",

  data() {
    return {
      tableData: [],
      templateTableData: [],
      searchForm: {
        TypeId: ""
      },
      modelTitle: '新增维护保养计划',
      dialogVisible: false,
      ruleForm: {
        "firstMaintain": null,
        "maintainInterval": null,
        "name": "",
        "code": "",
        "note": "",
        "deviceTypeId": null,
        "deviceTypeName": ""
      },
      templateForm:{
        'upText':'xxx',
        'LastId':null,
        "name": "",
        "code": "",
        "note": "",
        "maintainTypId": 0,
        "maintainScheduleId": 0,
        "fromLast": 0
      },
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        code: [
          {required: true, message: '请输入编号', trigger: 'blur'},
        ],
        firstMaintain: [
          {required: true, message: '请输入首次维护', trigger: 'blur'},
        ],
        maintainInterval: [
          {required: true, message: '请输入维护间隔', trigger: 'blur'},
        ],
      },
      show:false,
      templateVisible: false,
      areaId: '',
      maintainScheduleId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
    }
  },
  components: {
    //someComponent
    Pagination,
    DicInput
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (row.fromLast > 0) {
        return 'green-row';
      } else
        return '';
    },
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        TypeId: ""
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    fieldId(item, name) { // 字典
      if (item.id) {
        this.searchForm[name] = item.id
      } else {
        this.searchForm[name] = ''
      }
    },
    ruleFormFieldId(item, name) { // 字典
      if (item.id) {
        this.ruleForm[name] = item.id
        this.ruleForm.deviceTypeName = item.name
      } else {
        this.ruleForm[name] = ''
      }
    },
    templateFieldId(item, name) { // 模板字典
      if (item.id) {
        this.templateForm[name] = item.id
        this.templateForm.name = item.name
        this.templateForm.code = item.code
      } else {
        this.templateForm[name] = ''
      }
    },
    // 保养明细
    moreClick(id){
      this.maintainScheduleId=id
     this.moreList(this.maintainScheduleId)
    },
    moreList(id){
      this.axios
          .get("api/MaintainSchedule/GetMaintainDetails?ScheduleId="+id, )
          .then((res) => {
            this.templateTableData= res.list
            this.templateVisible=true
          })
    },
    topClick(row){ // 上移
      console.log()
      let to=''
      this.templateTableData.forEach((item,index)=>{
        if(item.id===row.id){
          to=this.templateTableData[index-1].id
          return
        }
      })
      this.axios.put('/MaintainSchedule/DetailChangeOrder?target='+row.id+'&to='+ to).then(res=>{
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.moreList(this.maintainScheduleId)
      })
    },
    bottomClick(row){ // 下移
      let to=''
      this.templateTableData.forEach((item,index)=>{
        if(item.id===row.id){
          to=this.templateTableData[index+1].id
          return
        }
      })
      this.axios.put('/MaintainSchedule/DetailChangeOrder?target='+row.id+'&to='+ to).then(res=>{
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.moreList(this.maintainScheduleId)
      })
    },
    addTemplate(row){
      this.templateForm={
        upText:row.name,
        LastId:row.id,
        "name": "",
        "code": "",
        "note": "",
        "maintainTypId": 0,
        "maintainScheduleId": 0,
        "fromLast": 0
      }
      this.show=true
    },
    firstAdd(){ // 首行新增
      this.show=false
      this.templateForm={
        upText:'',
        "name": "",
        "code": "",
        "note": "",
        "maintainTypId": 0,
        "maintainScheduleId": 0,
        "fromLast": 0
      }
    },
    delClick(row){
      this.axios.delete('/MaintainSchedule/DeleteDetail?id='+ row.id).then(res=>{
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.moreList(this.maintainScheduleId)
      })
    },
    editTemplate(row){
      this.templateForm={
        ...row
      }
      this.show=false
    },
    //模板明细新增
    templateSubmitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.templateForm.maintainTypId==='' || this.templateForm.maintainTypId===0){
            this.$message({
              message: '请选择类型名称！',
              type: 'warning'
            });
            return false
          }
          if(this.templateForm.id){
            let data= {
              ...this.templateForm,
              fromLast: Number(this.templateForm.fromLast),
              maintainScheduleId: this.maintainScheduleId,
            }
            this.axios
                .put("api/MaintainSchedule/EditDetail?id=" + this.templateForm.id, data).then((res) => {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.resetForm()
                this.moreList(this.maintainScheduleId)
            })
          }else {
            let data= {
              ...this.templateForm,
              fromLast: Number(this.templateForm.fromLast),
              maintainScheduleId: this.maintainScheduleId,
            }
            this.axios
                  .post("api/MaintainSchedule/PostDetail?LastId="+ (data.LastId?data.LastId:''), data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.resetForm()
              this.moreList(this.maintainScheduleId)
            })
          }
        } else {
          return false;
        }
      });
    },
    resetForm() {
     this.templateForm={
       'upText':this.templateForm.upText,
       "name": "",
       "code": "",
       "note": "",
       "maintainTypId": 0,
       "maintainScheduleId": 0,
       "fromLast": 0
     }
    },
    addItem() {
      this.modelTitle = '新增维护保养计划'
      this.ruleForm = {
        "firstMaintain": null,
        "maintainInterval": null,
        "name": "",
        "code": "",
        "note": "",
        "deviceTypeId": null,
        "deviceTypeName": ""
      }
      this.dialogVisible = true
      this.$nextTick(res => {
        this.$refs['ruleForm'].resetFields();
      })
    },
    editorClick(row) {
      this.modelTitle = '编辑维护保养计划'
      this.areaId = row.id
      this.ruleForm = {
        ...row,
      }
      this.dialogVisible = true
      this.$nextTick(res => {
        this.$refs['ruleForm'].resetFields();
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.deviceTypeId) {
            this.$message.error('系统无法查询到该设备型号');
            return
          }
          let data = {
            ...this.ruleForm,
          }
          if (this.modelTitle === '编辑维护保养计划') {
            this.axios
                .put("api/MaintainSchedule?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          } else {
            this.axios
                  .post("api/MaintainSchedule", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    // list
    init() {
      let data = {
        ...this.searchForm,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/MaintainSchedule", {params: data})
          .then((res) => {
            this.tableData = res.list
            // this.tableData.forEach(item => {
            //   switch (item.systemServiceType) {
            //     case 0:
            //       item.systemServiceTypeName = '数据库服务器'
            //       break;
            //     case 1:
            //       item.systemServiceTypeName = 'Api服务器'
            //       break;
            //     case 2:
            //       item.systemServiceTypeName = '采集服务器'
            //       break;
            //     case 3:
            //       item.systemServiceTypeName = '数据缓存服务器'
            //       break;
            //   }
            // })
            this.total = res.count
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>
<style>
.el-table .green-row {
  background: rgba(97, 175, 254, 0.1);
  color: black;
}
</style>
<style lang="scss" scoped>
.maintainTemplate {
}
</style>